import { BulkSendOrgMemberInvitationsRequestSchema, BulkSendOrgMemberInvitationsResponseSchema } from './bulk-send-org-member-invitations.schema';
/**
 * Bulk Send Org Member Invitations Endpoint Contract
 * Sends invitation emails to a batch of inactive organization members
 */ export const bulkSendOrgMemberInvitationsContract = {
    method: 'POST',
    path: '/api/v2/org-member/bulk-send-invitations',
    description: 'Send invitation emails to a batch of inactive organization members',
    requestSchema: BulkSendOrgMemberInvitationsRequestSchema,
    responseSchema: BulkSendOrgMemberInvitationsResponseSchema,
    statusCodes: {
        success: 200,
        errors: {
            400: 'Bad Request - invalid request body',
            401: 'Unauthorized - user not authenticated'
        }
    }
};

//# sourceMappingURL=bulk-send-org-member-invitations.contract.js.map